import React, { useState } from "react";
import * as OFMSUI from "react-bootstrap";
import { useHistory } from "react-router-dom";
import NavigationServicesHeader from "../Header/NavigationServicesHeader";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import { AiFillDelete, AiTwotoneEdit } from "react-icons/ai";
import { FormGroup, FormLabel, Row, Col, Button, Table, } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import * as Yup from "yup";
import HousingService from "../Services/HousingService";
import { store } from "../App";
import ShowAlert from "./alert";
import { BiUser } from "react-icons/bi";

function AddService() {
  const [data, setdata] = useState();
  const [parentidlist, setparentidlist] = useState();
  const [enable, setenable] = useState(true);
  const [enable1, setenable1] = useState(false);
  const [serviceName, setserviceName] = useState("Deafult value");
  const [Target, setTarget] = useState();
  const [parentid, setparentid] = useState();
  const [displayid, setdisplayid] = useState();
  const [serviceID, setServiceID] = useState();

  const history = useHistory();

  function handleGoBack() {
    history.goBack();
  }

  const formik = useFormik({
    initialValues: {
      target: "",
      serviceName: "",
      parentID: "",
      displayid: "",
      edittarget: "",
      editservicename: "",
      editParentId: "",
      editdisplayId: "",
    },
    validationSchema: Yup.object({
      target: Yup.string().required(),
      serviceName: Yup.string().required(),
      parentID: Yup.string().required(),
      displayid: Yup.string().required(),
    }),
    onSubmit: () => {
      let param = {
        parent_id: formik.values.parentID,
        display_id: formik.values.displayid,
        target: formik.values.target,
        service_name: formik.values.serviceName,
      };
      HousingService.submitService(param).then((res) => {
        if (res.data[0].responseToken === 1) {
          ShowAlert(res.data[0].responseMsg, "success").then(() => {
            history.go(0);
          })
        }
      }
      );
    },
  });

  React.useEffect(() => {
    HousingService.parentidlist().then((res) => {
      if (res.data) {
        let options = res.data[0].Parent_ID_List.map((item, i) => {
          return (
            <option key={i} value={item.service_id}>
              {item.service_name}
            </option>
          );
        });
        setparentidlist(options);
      }
    });

    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.addserviceslist().then((res) => {
      setdata(res.data[0].Parent_ID_List);

      store.dispatch({ type: "HIDE_SPINNER" });
    });
  }, []);

  const editData = (
    e,
    target,
    service_name,
    parent_id,
    priority,
    service_id
  ) => {
    e.preventDefault();
    HousingService.editData(service_id).then((res) => {
      formik.setFieldValue(
        "editParentId",
        res.data[0].Parent_ID_List[0].parent_id
      );
    });
    setTarget(target);
    setserviceName(service_name);
    setparentid(parent_id);
    setdisplayid(priority);
    setServiceID(service_id);
    setenable(false);
    setenable1(true);
    formik.setFieldValue("edittarget", target);
    formik.setFieldValue("editservicename", service_name);
    formik.setFieldValue("editdisplayId", priority);
  };
  const cancelit = () => {
    setenable(true);
    setenable1(false);
  };

  const updateDetails = () => {
    let params = {
      service_id: serviceID,
      parent_id: formik.values.editParentId,
      priority: formik.values.editdisplayId,
      target: formik.values.edittarget,
      service_name: formik.values.editservicename,
    };

    HousingService.updateDeatil(params).then(
      (res) => {
        if (res.data[0].responseToken === 1) {
          ShowAlert(res.data[0].responseMsg, "success").then(() => {
            history.go(0);
          })
        }
      }
    );
  };

  const deleteDatabyId = (service_id) => {
    HousingService.deleteData(service_id).then(
      (res) => {
        if (res.data[0].responseToken === 1) {
          ShowAlert(res.data[0].responseMsg, "success").then(() => {
            history.go(0);
          })
        }
      }
    );
  };

  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className="page-titlespacing" >
            <div className="inner-herbpage-service-title1"> <h1>ADD SERVICE</h1> </div>
          </OFMSUI.Col>

          <OFMSUI.Col xs={12} sm={12} md={1} lg={1} xl={1} xxl={1} className="page-titlespacing" >
            <button type="button" className="btn btn-outline-primary" style={{ textAlign: "right", float: "right", marginTop: "17px", }} onClick={handleGoBack} > Back </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>

      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }} >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            {enable && (
              <>
                <OFMSUI.Row className="p-3" style={{ textAlign: "left" }}>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                    <OFMSUI.FormGroup as={Col}>
                      <OFMSUI.FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Target </h6> </OFMSUI.FormLabel> <span className="mandatory" style={{ color: "red" }}> * </span>
                      <Field type="text" name="target" className={formik.touched.target && formik.errors.target ? "form-control is-invalid" : "form-control"} />
                      {formik.touched.target && formik.errors.target && (<div className="invalid-feedback"> <span style={{ color: 'red' }}>required</span> </div>)}
                    </OFMSUI.FormGroup>
                  </OFMSUI.Col>

                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                    <OFMSUI.FormGroup as={Col}>
                      <OFMSUI.FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Service Name </h6> </OFMSUI.FormLabel> <span className="mandatory" style={{ color: "red" }}> * </span>
                      <Field type="text" name="serviceName" className={formik.touched.serviceName && formik.errors.serviceName ? "form-control is-invalid" : "form-control"} onChange={(e) => formik.setFieldValue("serviceName", e.target.value.toUpperCase())} />
                      {formik.touched.serviceName && formik.errors.serviceName && (<div className="invalid-feedback"> <span style={{ color: 'red' }}>required</span> </div>)}
                    </OFMSUI.FormGroup>
                  </OFMSUI.Col>

                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                    <OFMSUI.FormGroup as={Col}>
                      <OFMSUI.FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} >Parent ID </h6> </OFMSUI.FormLabel> <span className="mandatory" style={{ color: "red" }}> * </span>
                      <Field name="parentID" component="select" className={formik.touched.parentID && formik.errors.parentID ? "form-control is-invalid" : "form-control"} > <option>Select</option> {parentidlist} </Field>
                      {formik.touched.parentID && formik.errors.parentID && (<div className="invalid-feedback"> <span style={{ color: 'red' }}>required</span> </div>)}
                    </OFMSUI.FormGroup>
                  </OFMSUI.Col>

                  <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                    <OFMSUI.FormGroup as={Col}>
                      <OFMSUI.FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Priority ID </h6> </OFMSUI.FormLabel> <span className="mandatory" style={{ color: "red" }}> * </span>
                      <Field type="text" name="displayid" className={formik.touched.displayid && formik.errors.displayid ? "form-control is-invalid" : "form-control"} ></Field>
                      {formik.touched.displayid && formik.errors.displayid && (<div className="invalid-feedback"> <span style={{ color: 'red' }}>required</span> </div>)}
                    </OFMSUI.FormGroup>
                  </OFMSUI.Col>

                  <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} > <button type="submit" className="btn btn-secondary btn-md float-left mx-1" style={{ marginTop: '35px' }}> Add </button> </OFMSUI.Col>
                </OFMSUI.Row>

                <OFMSUI.Table striped bordered hover id="my-table">
                  <thead className="fw-bold">
                    <tr className="table_countshead">
                      <th>S.No.</th>
                      <th>Service Name</th>
                      <th>Target</th>
                      <th>Priority Order</th>
                      <th>Parent ID</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((detail, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td style={{ textAlign: 'left' }}>{detail.service_name}</td>
                        <td style={{ textAlign: 'left' }}>{detail.target}</td>
                        <td style={{ textAlign: 'left' }}>{detail.priority}</td>
                        <td style={{ textAlign: 'left' }}>{detail.parent_id}</td>
                        <td>
                          <FaEdit
                            title="EDIT" onClick={(e) => { editData(e, detail.target, detail.service_name, detail.parent_id, detail.priority, detail.service_id); }} style={{ cursor: "pointer" }} />
                          &nbsp;&nbsp;
                          <AiFillDelete title="DELETE" style={{ cursor: "pointer" }} onClick={() => { deleteDatabyId(detail.service_id); }} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </OFMSUI.Table>
              </>
            )}

            {enable1 && (
              <>
                <OFMSUI.Row className="p-3" style={{ textAlign: "left" }}>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                    <OFMSUI.FormGroup as={Col}>
                      <OFMSUI.FormLabel>
                        <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Target </h6>
                      </OFMSUI.FormLabel>
                      <span className="mandatory" style={{ color: "red" }}> * </span>
                      <Field type="text" name="edittarget" className={"form-control"} ></Field>
                    </OFMSUI.FormGroup>
                  </OFMSUI.Col>

                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                    <OFMSUI.FormGroup as={Col}>
                      <OFMSUI.FormLabel>
                        <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Service Name </h6>
                      </OFMSUI.FormLabel>
                      <span className="mandatory" style={{ color: "red" }}> * </span>
                      <Field type="text" name="editservicename" className={"form-control"} ></Field>
                    </OFMSUI.FormGroup>
                  </OFMSUI.Col>

                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                    <OFMSUI.FormGroup as={Col}>
                      <OFMSUI.FormLabel>
                        <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} >Parent ID </h6>
                      </OFMSUI.FormLabel>
                      <span className="mandatory" style={{ color: "red" }}> * </span>
                      <Field name="editParentId" component="select" className={formik.touched.editParentId && formik.errors.editParentId ? "form-control is-invalid" : "form-control"} >
                        <option>Select</option>
                        {parentidlist}
                      </Field>
                    </OFMSUI.FormGroup>
                  </OFMSUI.Col>

                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                    <OFMSUI.FormGroup as={Col}>
                      <OFMSUI.FormLabel>
                        <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Display ID </h6>
                      </OFMSUI.FormLabel>
                      <span className="mandatory" style={{ color: "red" }}> * </span>
                      <Field type="text" name="editdisplayId" className={"form-control"} ></Field>
                    </OFMSUI.FormGroup>
                  </OFMSUI.Col>
                </OFMSUI.Row>

                <OFMSUI.Row className="p-3" style={{ textAlign: "left" }}>
                  <OFMSUI.Col xs={12} sm={12} md={2} lg={2} xl={2} xxl={2}>
                    <button type="button" onClick={() => { updateDetails(); }} className="btn btn-primary btn-sm  mb-2 float-left mx-1" > Update </button>
                    <button type="button" onClick={() => { cancelit(); }} className="btn btn-danger btn-sm  mb-2 float-left" > Cancel </button>
                  </OFMSUI.Col>

                  <OFMSUI.Col xs={12} sm={12} md={10} lg={10} xl={10} xxl={10}>
                    &nbsp;
                  </OFMSUI.Col>
                </OFMSUI.Row>
              </>
            )}
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default AddService;





// .catch((error)=>{
//   ShowAlert("Somme error occured",error)
// }).finally(()=>{
//   store.dispatch({ type: "HIDE_SPINNER" });
// });